import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Privacy() {
  return (
    <div className="three-fourths columns medium-down--one-whole offset-by-two is-hidden-offset-mobile-only">
        <h1>Privacy Policy</h1>
        <div className="feature-divider" />
        <div className="rte">
        <p><strong>Last updated: September 22, 2026</strong></p>
        <p>baplehollow is operated by Hong Kong Ruijingsheng Trading Co., Limited.</p>
        <h3>Information we collect</h3>
        <p>When you place an order or contact us, baplehollow may collect your name, email address, delivery address, country, order details and the content of your message. We do not ask you to enter card numbers on this website.</p>
        <h3>How we use information</h3>
        <p>We use information to process and deliver orders, provide support, prevent fraud, meet legal obligations, improve site reliability and maintain transaction records. We do not use checkout contact details for promotional mailing.</p>
        <h3>Payment processing</h3>
        <p>After you confirm checkout, you are redirected to our payment endpoint and its payment-service flow. The payment provider processes payment credentials under its own privacy terms. We receive transaction status and identifiers needed to match payment to an order.</p>
        <h3>Sharing</h3>
        <p>We share only the information reasonably needed with payment, hosting, security, analytics, fulfilment and delivery providers, or with authorities when required by law. We do not sell personal information.</p>
        <h3>Retention and security</h3>
        <p>Order and support records are retained only as long as needed for fulfilment, disputes, accounting, fraud prevention and legal requirements. We apply reasonable technical and organisational safeguards, but no internet transmission is risk free.</p>
        <h3>Your choices and rights</h3>
        <p>You may request access, correction or deletion of eligible personal information and may object to or restrict certain processing where applicable. Identity verification may be required.</p>
        <h3>Cookies</h3>
        <p>We use necessary browser storage for the shopping cart and may use limited preference or measurement cookies. See our <Link to="/cookies">Cookie Policy</Link> for details and controls.</p>
        <h3>International processing</h3>
        <p>Service providers may process information outside your location. Where required, appropriate safeguards are used for those transfers.</p>
        <h3>Children</h3>
        <p>This store is not directed to children, and we do not knowingly collect personal information from children without appropriate authorisation.</p>
        <h3>Contact</h3>
        <p>
          Email privacy questions or requests to <a href="mailto:model@baplehollow.online">model@baplehollow.online</a>.
          Business address: RM 12, UNIT 12A, 13/F, BLOCK 1, CAMEL PAINT
          BUILDING, 62 HOI YUEN ROAD, KWUN TONG, HONG KONG.
        </p>
      </div>
    </div>
  );
}

export default Privacy;
